export const deleteFromServer = async (functionParameters = {}) => {

    const axios = (await import(/* webpackPrefetch: true */ `axios`)).default;
    // const displaySmartboxWithPreloader = (await import(/* webpackPrefetch: true */ `../../display/displaySmartboxWithPreloader.js`)).displaySmartboxWithPreloader;

    const { token, deleteApiEndPoint, preloader, smetioSmartbox, clickWhenDone  } = functionParameters;

    preloader.show();

    const appClass = window.smetioApp;

    const apiEndPoint = window.apiEndPoint;
    const language = window.userLanguage;
    const sideMenuItems = window.currentSideMenuItems;

    const res = await axios.post(deleteApiEndPoint, { token } ).then(async (response) => {

        let model = response.data;

        if (model.error) return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: model.msg }] });

        if (model.success) window.smetioVisitor.showNotification({ type:"success", body: [{ message: model.msg }] });
        
        smetioSmartbox.close();
    
        sideMenuItems[clickWhenDone].onClick();       

    }).catch((error) => {

        console.log(error);
        return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: "txt423" }] });

    }).finally(() => {
        preloader.hide();
    });

};


